import { FunctionComponent } from 'react';
import { Link, Stack, SvgIcon, Typography, useTheme } from '@mui/material';
import ArrowLeftIcon from '@heroicons/react/24/solid/ArrowLeftIcon';

import { useGetTicketsQuery } from '@starjack/entities/ticket';
import { useParams } from 'react-router-dom';
import { TicketsDetailsCard } from '@/pageContents/tickets/TicketsDetailsCard';

export const TicketDetailsContent: FunctionComponent = () => {
    const { id } = useParams();
    const { data } = useGetTicketsQuery({
        orderId: id!,
    });
    const theme = useTheme();

    return (
        <Stack spacing={theme.page.verticalSpacing}>
            <Link
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    mb: 6,
                }}
                href='/tickets'
            >
                <SvgIcon
                    fontSize='small'
                    sx={{
                        mr: 2,
                    }}
                >
                    <ArrowLeftIcon />
                </SvgIcon>

                <Typography variant='subtitle2' component='span'>
                    Tickets
                </Typography>
            </Link>

            {!!data && (
                <Stack spacing={theme.page.verticalSpacing}>
                    <Typography variant='h4'>Ticketdetails</Typography>

                    <TicketsDetailsCard ticket={data?.content[0]} />
                </Stack>
            )}
        </Stack>
    );
};
